import get from 'lodash/get';
import States from './ticket_states';

// these props are expected on a ticket stub
const TYPE = 'type';
const LEVEL = 'level';
const SECTION = 'sec';
const ROW = 'row';
const SEAT = 'seat_num';

function isDisabled (ticket) {
  const tmp = ticket || {};

  return tmp.status === States.CANCELLED ||
  tmp.secondaryMarketStatus === States.SOLD_ON_SECONDARY_MARKET;
}

function getTicketListItemType (obj) {
  const tmp = obj || {};

  if (isTicket(tmp)) return getTicketLayoutType(tmp.seat_name);
  if (isUpsell(tmp)) return States.UPSELL;

  return '';
}

function isTicket (obj) {
  return typeof get(obj, 'seat_name') === 'object';
}

function isUpsell (obj) {
  return get(obj, 'name', '').length > 0;
}

function keyToString (obj) {
  return function (acc, key) {
    if (obj[key] !== undefined && obj[key] !== null) {
      acc[key] = obj[key] + '';
    }
    return acc;
  };
}

function getTicketLayoutType (obj) {
  const tmp = Object.keys(obj).reduce(keyToString(obj), {});

  if (isTypeLevelSectionRowSeat(tmp)) return States.TYPE_LEVEL_SECTION_ROW_SEAT_TICKET;
  if (isLevelSectionRowSeat(tmp))     return States.LEVEL_SECTION_ROW_SEAT_TICKET;
  if (isTypeLevelSectionRow(tmp))     return States.TYPE_LEVEL_SECTION_ROW_TICKET;
  if (isTypeLevelRowSeat(tmp))        return States.TYPE_LEVEL_ROW_SEAT_TICKET;
  if (isTypeSectionRowSeat(tmp))      return States.TYPE_SECTION_ROW_SEAT_TICKET;
  if (isTypeLevelSection(tmp))        return States.TYPE_LEVEL_SECTION_TICKET;
  if (isTypeSectionRow(tmp))          return States.TYPE_SECTION_ROW_TICKET;
  if (isSectionRowSeat(tmp))          return States.SECTION_ROW_SEAT_TICKET;
  if (isLevelRowSeat(tmp))            return States.LEVEL_ROW_SEAT_TICKET;
  if (isTypeSection(tmp))             return States.TYPE_SECTION_TICKET;
  if (isLevelSection(tmp))            return States.LEVEL_SECTION_TICKET;
  if (isTypeLevel(tmp))               return States.TYPE_LEVEL_TICKET;
  if (isLevel(tmp))                   return States.LEVEL_TICKET;
  if (isSection(tmp))                 return States.SECTION_TICKET;

  return '';
}

function isTypeLevel (obj) {
  return get(obj, LEVEL, '').length > 0 && get(obj, TYPE, '').length > 0;
}

function isTypeLevelSectionRowSeat (obj) {
  return get(obj, TYPE, '').length > 0 &&
  get(obj, LEVEL, '').length > 0 &&
  get(obj, SECTION, '').length > 0 &&
  get(obj, ROW, '').length > 0 &&
  get(obj, SEAT, '').length > 0;
}

function isTypeSectionRowSeat (obj) {
  return get(obj, TYPE, '').length > 0 &&
  get(obj, SECTION, '').length > 0 &&
  get(obj, ROW, '').length > 0 &&
  get(obj, SEAT, '').length > 0;
}

function isTypeLevelSectionRow (obj) {
  return get(obj, TYPE, '').length > 0 &&
  get(obj, SECTION, '').length > 0 &&
  get(obj, ROW, '').length > 0 &&
  get(obj, LEVEL, '').length > 0;
}

function isLevelSectionRowSeat (obj) {
  return get(obj, SEAT, '').length > 0 &&
  get(obj, SECTION, '').length > 0 &&
  get(obj, ROW, '').length > 0 &&
  get(obj, LEVEL, '').length > 0;
}

function isTypeSectionRow (obj) {
  return get(obj, TYPE, '').length > 0 &&
  get(obj, SECTION, '').length > 0 &&
  get(obj, ROW, '').length > 0;
}

function isTypeLevelSection (obj) {
  return get(obj, TYPE, '').length > 0 &&
  get(obj, SECTION, '').length > 0 &&
  get(obj, LEVEL, '').length > 0;
}

function isSectionRowSeat (obj) {
  return get(obj, ROW, '').length > 0 &&
  get(obj, SECTION, '').length > 0 &&
  get(obj, SEAT, '').length > 0;
}

function isLevelRowSeat (obj) {
  return get(obj, ROW, '').length > 0 &&
  get(obj, LEVEL, '').length > 0 &&
  get(obj, SEAT, '').length > 0;
}

function isTypeSection (obj) {
  return get(obj, TYPE, '').length > 0 &&
  get(obj, SECTION, '').length > 0;
}

function isLevelSection (obj) {
  return get(obj, LEVEL, '').length > 0 &&
  get(obj, SECTION, '').length > 0;
}

function isLevel (obj) {
  return get(obj, LEVEL, '').length > 0;
}

function isSection (obj) {
  return get(obj, SECTION, '').length > 0;
}

function isTypeLevelRowSeat (obj) {
  return get(obj, TYPE, '').length > 0 &&
  get(obj, LEVEL, '').length > 0 &&
  get(obj, ROW, '').length > 0 &&
  get(obj, SEAT, '').length > 0;
}

const funcs = {
  getTicketListItemType: getTicketListItemType,
  isDisabled: isDisabled
};

const props = {
  TYPE: TYPE,
  LEVEL: LEVEL,
  SECTION: SECTION,
  ROW: ROW,
  SEAT: SEAT
};

export default  Object.assign(props, States, funcs);



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/ticket_stub_utils.js